export const primaryColor = "#E70070";
export const secondaryColor = "#770141";
export const gridColor = "#B7B7B7";
export const stackedBarSpacing = 0.8;
export const toolTipBackground = "#fff";